<template>
    <div class="toolbox-footer">
    <!--
    Example of additional content in toolbox footer
      <button class="btn-icon icon-close"></button>
      <h3>Edit my GeoObject here :)</h3>
      <div class="formItem">
        <label>Input</label>
        <v-text-field solo flat hide-details class="sr-input" label="Name" placeholder="Enter name" value="Objekt im Zentrum von Wabern"></v-text-field>
      </div>
    -->
    <v-btn
            @click="save()"
            class="sr-button"
            text
            :loading="loading"
            :disabled="loading"
    >
        Speichern
    </v-btn>
</div>
</template>

<script>
  import { VDivider, VCardActions, VBtn } from 'vuetify/lib'

  export default {
    components: {
      VDivider,
      VCardActions,
      VBtn,
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    methods: {
      close () {
        this.$emit('close')
      },
      save () {
        this.$emit('save')
      }
    }
  }
</script>

<style scoped>

</style>
